import styled from 'styled-components';
import ToggleButton from '@elementary/common-ui/components/ToggleButton';

const DialogToggleButton = styled(ToggleButton)`
  gap: 8px;
  font-size: 16px;
  svg path {
    fill: ${({ theme }) => theme.palette.common.gray12};
  }
  &.Mui-selected {
    background: ${({ theme }) => theme.palette.common.lightBlue3};
    color: ${({ theme }) => theme.palette.secondary.main};
    font-weight: 500;

    svg path {
      fill: ${({ theme }) => theme.palette.secondary.main};
    }
  }
  &:hover {
    background: ${({ theme }) => theme.palette.common.gray10} !important;
  }
`;

export default DialogToggleButton;
